import { render, staticRenderFns } from "./Publish.vue?vue&type=template&id=f5040084&scoped=true"
import script from "./Publish.vue?vue&type=script&lang=ts"
export * from "./Publish.vue?vue&type=script&lang=ts"
import style0 from "./Publish.vue?vue&type=style&index=0&id=f5040084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5040084",
  null
  
)

export default component.exports